import React from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';

import { withTranslation } from 'language/i18n';
import Breadcrumb from 'components/Breadcrumb';
import Layout from 'components/partials/Layout';
import LeftMenu from '../components/buying/LeftMenu';
import ContactUs from '../components/ContactUs';
import Feature from '../components/buying/Feature';
import BuyForOfferMachine from '../components/BuyForOfferMachine';

const AssuranceOfIyiMakina = ({ t }) => {
  const breadcrumbs = [
    {
      label: t('homepage'),
      url: '/',
    },
    {
      label: t('buying'),
      url: '/content/buying/before-bidding',
    },
    {
      label: 'iyiMakina.com Güvencesi',
      url: '/content/buying/assurance-of-iyimakina',
    },
  ];

  const items = [
    {
      title: 'Uzman Ekip',
      description: 'Alanında uzman, yetkili ekspertiz ekibi makinaların kapsamlı ekspertiz raporlarını çıkartır.',
      svgIcon: '/image/icons.svg#ic-briefcase-yellow',
    },
    {
      title: 'Detaylı Rapor',
      description: 'Makinanın motor, yağ, saşe, genel görünüm gibi birçok detayını görüntü ve videolarla ayrıntılı bir raporda sunar.',
      svgIcon: '/image/icons.svg#ic-checklist-yellow',
    },
    {
      title: 'Güvence',
      description: 'Sunulan ekspertiz raporunun dışında hata, eksik ve hasar olmayacağını garanti eder.',
      svgIcon: '/image/icons.svg#ic-thumbs-up-yellow',
    },
  ];

  return (
    <main className="has-header">
      <div className="container">
        <div className="row mt-4 mb-4 mt-lg-3 mb-lg-3">
          <div className="col">
            <Breadcrumb links={breadcrumbs} />
          </div>
        </div>
        <div className="row">
          <LeftMenu currentPage="assurance-of-iyimakina" />
          <div className="col-md-10 col-lg-11 mt-3 mt-md-0">
            <div className="row mb-20">
              <div className="col">
                <h1 className="h1">iyiMakina.com Güvencesi</h1>
              </div>
            </div>
            <div className="row mb-20">
              <div className="col-15 col-lg-3 mb-4 mb-lg-0 text-center">
                <img className="img-responsive d-inline-block mw-115" src="/temp/expertise-stamp.svg" alt="" srcSet="" />
              </div>
              <div className="col-15 col-lg-12">
                <p>
                  Yetkili ekspertiz ekibi makinaları inceleyip, kapsamlı ve eksiksiz bir ekspertiz raporu hazırlar ve bu raporlar sitede yayınlanmak üzere iyiMakina’ya teslim edilir.
                  Ekspertiz rapolarımız; genel görünüm, kabin, motor, hidrolik, şase ve yağ analizi olmak üzere detaylı inceleme raporlarını ayrıca makinaların detaylı görüntüleri ve videolarını kapsamaktadır.
                </p>
                <p>
                  Platformumuzda satışa çıkan tüm makinalar, iyiMakina Güvencesi kapsamındadır.
                  iyiMakina Güvencesi, sunduğu ekspertiz raporunun dışında; makinada eksik, hata ve hasar bulunmayacağını garanti etmektedir.
                </p>
              </div>
            </div>
            <div className="row mb-20">
              <div className="col-15">
                <h2 className="h5">Ücretsiz İnceleyin</h2>
              </div>
              <div className="col-15">
                <p className="mb-0">
                  Satışa çıkan makinaların detaylı ekspertiz raporları, makinanın ilan sayfasında yer almaktadır. Ekspertiz raporu, detaylı görsel ve videoları ücretsiz olarak inceleyebilirsiniz.
                </p>
              </div>
            </div>
            <div className="row mb-30 align-items-stretch" style={{ rowGap: '20px' }}>
              {
                _.map(items, (item, index) => (
                  <Feature key={index} data={item} />
                ))
              }
            </div>
            <BuyForOfferMachine />
            <ContactUs about="iyiMakina.com Güvencesiyle" />
          </div>
        </div>
      </div>
    </main>
  );
};

AssuranceOfIyiMakina.propTypes = {
  t: PropTypes.func,
};

export const getServerSideProps = async () => {
  return {
    props: {
      blackHeader: true,
      headTitle: 'iyiMakina.com Güvencesi',
    },
  };
};

AssuranceOfIyiMakina.Layout = Layout;

export default withTranslation('common')(AssuranceOfIyiMakina);
